import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {RouteParam} from "../../types/types";
import {useStepCheck} from "../../hooks/stepcheck/useStepCheck";
import {DataConsentViewModel} from "../../viewmodel/data-consent/DataConsentViewModel";
import {HeaderComponent} from "../../components/common/header/HeaderComponent";
import {ButtonComponent} from "../../components/common/button/ButtonComponent";
import './DataConsent.scss';
import ProcessingComponent from "../../components/common/processing/ProcessingComponent";

const DataConsentPage: React.FC = () => {

    const { verificationId } = useParams<RouteParam>();
    const { onSubmit, loading } = DataConsentViewModel(verificationId)
    const { evaluateUrl } = useStepCheck(verificationId)

    useEffect(() => {
        evaluateUrl()
    }, [evaluateUrl])

    return !loading ? (
                <div className={`background background-white general-container information-container height-window`}>
                    <HeaderComponent
                        title="Data consent"
                        subtitle="We’re required to collect your name, date of birth and address to check with the document issuer, official record holder, a credit bureau and authorised third parties for verification purposes."
                        progress={10}/>
                    <div className={`width-full flex-center`}>
                        <p className={`font-md-plus font-400`}>
                            Part of this process requires the use of your camera to capture images of your identity
                            documents
                            and
                            yourself.
                        </p>

                    </div>
                    <div className={`information-container-button width-full flex-center`}>
                        <p className={`font-sm`}>
                            I confirm that I have read and accept<br/> the above data consent.
                        </p>
                        <ButtonComponent label="Accept and continue" className={`consent-button`}
                                         onButtonClick={() => onSubmit()} disableOnClick/>
                    </div>
                </div>
            ) : (<ProcessingComponent loadingAnimation="processing" successAnimation="processingSuccess" success={false} noText/>)

}

export default DataConsentPage